/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { Competenza } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const getBackTipiProcedimentoIdCompetenze = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Competenza[]>(
    {
      url: `/framework-bo-procedimenti/tipi-procedimento/${id}/competenze`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackTipiProcedimentoIdCompetenzeQueryKey = (id: string) =>
  [`/framework-bo-procedimenti/tipi-procedimento/${id}/competenze`] as const;

export const getGetBackTipiProcedimentoIdCompetenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackTipiProcedimentoIdCompetenzeQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>
  > = ({ signal }) =>
    getBackTipiProcedimentoIdCompetenze(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetBackTipiProcedimentoIdCompetenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>
>;
export type GetBackTipiProcedimentoIdCompetenzeQueryError = ErrorType<unknown>;

export const useGetBackTipiProcedimentoIdCompetenze = <
  TData = Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackTipiProcedimentoIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackTipiProcedimentoIdCompetenzeQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
